import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './List';
import Edit from './Edit';
import { TabMenu, MenuItem } from '@smartplatform/ui';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { CityList } from './cities/List';
import { CityEdit } from './cities/Edit';
import { AddressList } from './addresses/List';
import { AddressEdit } from './addresses/Edit';

const menuItems = [
	{
		label: 'Избирательные округи',
		id: '',
	},
	{
		label: 'Населенные пункты',
		id: 'cities',
	},
	{
		label: 'Адреса',
		id: 'addresses',
	},
];

@observer
export default class Divisions extends React.Component {
	@observable tab;

	switchTab = record => {
		this.tab = record.id;
		this.props.history.push(`/admin/divisions/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		const rootPath = '/admin/divisions';
		if (store.route.path === rootPath) {
			this.switchTab(menuItems[0]);
		}

		return (
			<div>
				<TabMenu>
					{menuItems.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>
				<Switch>
					<Route path={rootPath + '/addresses'} exact component={() => <AddressList rootPath={rootPath} tabName="addresses" />} />
					<Route path={rootPath + '/addresses/:id'} exact component={AddressEdit} />
					<Route path={rootPath + '/cities'} exact component={() => <CityList rootPath={rootPath} tabName="cities" />} />
					<Route path={rootPath + '/cities/:id'} exact component={CityEdit} />
					<Route path={rootPath} exact component={List} />
					<Route path={rootPath + '/:id'} exact component={Edit} />
				</Switch>
			</div>
		);
	}
}
